import { render, staticRenderFns } from "./ModalSubmitProduct.vue?vue&type=template&id=cea0b2a4&scoped=true&"
import script from "./ModalSubmitProduct.vue?vue&type=script&lang=js&"
export * from "./ModalSubmitProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea0b2a4",
  null
  
)

export default component.exports